// Circuit Breaker Pattern for API calls
export class CircuitBreaker {
  private static instance: CircuitBreaker
  private failureCount: number = 0
  private lastFailureTime: number = 0
  private state: 'CLOSED' | 'OPEN' | 'HALF_OPEN' = 'CLOSED'
  private readonly failureThreshold: number = 3
  private readonly timeout: number = 30000 // 30 seconds

  private constructor() {}

  public static getInstance(): CircuitBreaker {
    if (!CircuitBreaker.instance) {
      CircuitBreaker.instance = new CircuitBreaker()
    }
    return CircuitBreaker.instance
  }

  public async execute<T>(fn: () => Promise<T>): Promise<T> {
    if (this.state === 'OPEN') {
      if (Date.now() - this.lastFailureTime > this.timeout) {
        this.state = 'HALF_OPEN'
      } else {
        throw new Error('Circuit breaker is OPEN - API calls are temporarily disabled')
      }
    }

    try {
      const result = await fn()
      this.onSuccess()
      return result
    } catch (error) {
      this.onFailure()
      throw error
    }
  }

  private onSuccess(): void {
    this.failureCount = 0
    this.state = 'CLOSED'
  }

  private onFailure(): void {
    this.failureCount++
    this.lastFailureTime = Date.now()
    
    if (this.failureCount >= this.failureThreshold) {
      this.state = 'OPEN'
      console.warn('Circuit breaker opened due to repeated failures')
    }
  }

  public isOpen(): boolean {
    return this.state === 'OPEN'
  }

  public reset(): void {
    this.failureCount = 0
    this.state = 'CLOSED'
    this.lastFailureTime = 0
  }
}

export default CircuitBreaker.getInstance()
